__turbopack_context__.v({
  "animateCard": "IntroSection-module__y9FCiW__animateCard",
  "animateCta": "IntroSection-module__y9FCiW__animateCta",
  "animateSocial": "IntroSection-module__y9FCiW__animateSocial",
  "animateText": "IntroSection-module__y9FCiW__animateText",
  "backgroundContainer": "IntroSection-module__y9FCiW__backgroundContainer",
  "centerGlow": "IntroSection-module__y9FCiW__centerGlow",
  "copyable": "IntroSection-module__y9FCiW__copyable",
  "drift": "IntroSection-module__y9FCiW__drift",
  "fadeInScale": "IntroSection-module__y9FCiW__fadeInScale",
  "fadeInUp": "IntroSection-module__y9FCiW__fadeInUp",
  "float": "IntroSection-module__y9FCiW__float",
  "glowBorder": "IntroSection-module__y9FCiW__glowBorder",
  "gridPattern": "IntroSection-module__y9FCiW__gridPattern",
  "particle": "IntroSection-module__y9FCiW__particle",
  "particle1": "IntroSection-module__y9FCiW__particle1",
  "particle2": "IntroSection-module__y9FCiW__particle2",
  "particle3": "IntroSection-module__y9FCiW__particle3",
  "particle4": "IntroSection-module__y9FCiW__particle4",
  "particle5": "IntroSection-module__y9FCiW__particle5",
  "pulse": "IntroSection-module__y9FCiW__pulse",
  "techCard": "IntroSection-module__y9FCiW__techCard",
  "techIcon": "IntroSection-module__y9FCiW__techIcon",
});
